<template>
<div class="home">
    <div class="fang_main" v-loading="default_the_load">
        <SideBar @childFn="parentFn" v-bind:the_default_load="the_default_load"></SideBar>
      
        <div class="right-container" :class="{ 'collapse-ml': isCollapse }">
            <div class="right1">
                <TopBar></TopBar>
            </div>
            <div class="right2">
                <AppMain></AppMain>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from "vuex";

import SideBar from "./feng/sidebar";
import TopBar from "./feng/topbar";
import AppMain from "./feng/appmain";
export default {
    // 计算机属性 .__mode
    computed: {
        ...mapState({
            isCollapse: (state) => state.common.isCollapse,
        }),
    },
    data () {
        return {
            the_default_load:'',
            default_the_load:true,
        }
    },
    components: {
        SideBar,
        TopBar,
        AppMain,
    },
    mounted() {
       console.log(this.the_default_load,'父组件',this.default_the_load)
      
      this.parentFn(this.default_the_load)
        // window.location.reload()
    },
    methods: {
         parentFn (a) {
      console.log('触发了父组件的方法' + '======' + a ,  this.default_the_load);
      this.default_the_load=a
      console.log(  this.default_the_load,'这是什么数据啊')
    //   this.default_the_load=false
    }
    }
};
</script>

<style lang="less" scoped>
html {
    overflow-x: hidden;
    overflow-y: auto;
}

* {
    margin: 0;
    padding: 0;
}

.right-container {
    flex: 1;
    width: 84%;
    min-height: 100%;
    margin-left: 14%;
    transition: margin-left 0.28s;
    height: 100%;
    display: flex;
    background: #f1f1f1;
    flex-direction: column;
    overflow: hidden;
}

.right1 {
    // margin: 10px;
    // margin-bottom: 0;
    // height: 72px;
    box-sizing: border-box;
    background: #F2F6FB;
    border-bottom: 2px solid #D2D7E6;
    border-top: 2px solid #D2D7E6;
}

.right2 {
    flex: 1;
    overflow: auto;
    background: #f1f1f1;
    margin: 10px;
}

.collapse-ml {
    margin-left: 64px;
    .main1{
        width: calc(89vw + 10px)
    }
}

.el-menu {
    background: none;
}

.left-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    // background: #1d66dc;
}

.left-top img {
    width: 80%;
    display: block;
    padding: 10px 0;
}

.is-expanded {
    color: #f0f;
}

.home {
    height: 100%;
   
        //   display: revert !important;
  
    // text-align: center;
}

* {
    margin: 0;
    padding: 0;
    list-style: none;
}

.header {
    width: 100%;
    height: 100px;
    background: #ccc;
    line-height: 100px;
}

.fang_main {
    display: flex;
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    margin-top: 0;
}

.ml {
    width: 14%;
    background: #303743;

    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: 2px 0 8px 0 rgba(29, 35, 41, 0.05);
}

.left1 {
    overflow: auto;
    flex: 1;
}

.xin {
    overflow: auto;
    flex: 1;
    height: 100%;
}

.right {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #f1f1f1;
}

.right-top {
    background: #2b3542;
    height: 40px;
    color: aliceblue;
    display: flex;
    justify-content: space-between;
}

.right-top p {
    width: 0%;
}

.right-top ul {
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: right;
}

.router-link-active {
    color: #f0f;
}

.button {
    margin-left: 20px;
    width: 80px;
    height: 30px;
}

.el-menu {
    border-right: none;
}

/deep/ .el-menu-item:hover {
    background: #151515 !important;
    color: #006BE7 !important;
}

/deep/ .el-submenu__title:hover {
    background: #151515 !important;
    color: #006BE7 !important;
}

</style>
